module.exports = __webpack_public_path__ + "static/media/BC_profile_pic.d1734e4f.jpg";